<template>
  <b-modal
    v-model="isOpen"
    hide-header
    hide-footer
    centered
    modal-class="admin-outcome-modal"
  >
    <div class="outcome-wrap text-center">
      <button
        type="button"
        class="outcome-close"
        aria-label="Close"
        @click="close"
      >
        <feather-icon
          icon="XIcon"
          size="18"
        />
      </button>

      <div
        class="outcome-icon"
        :class="`outcome-icon--${variant}`"
      >
        <feather-icon
          :icon="iconName"
          size="42"
        />
      </div>

      <h3 class="outcome-title">
        {{ resolvedTitle }}
      </h3>
      <p class="outcome-message">
        {{ resolvedMessage }}
      </p>

      <b-button
        variant="primary"
        class="outcome-btn"
        block
        @click="onPrimary"
      >
        {{ resolvedPrimaryLabel }}
      </b-button>
      <b-button
        v-if="resolvedSecondaryLabel"
        variant="outline-secondary"
        class="outcome-btn-secondary mt-1"
        block
        @click="onSecondary"
      >
        {{ resolvedSecondaryLabel }}
      </b-button>
    </div>
  </b-modal>
</template>

<script>
import { BModal, BButton } from 'bootstrap-vue'

const PRESETS = {
  'ad-approved': {
    icon: 'CheckCircleIcon',
    title: 'Ad Approved',
    message: 'The ad has been approved and is now live.',
    primaryLabel: 'Back to Ads Management',
  },
  'ad-removed': {
    icon: 'XCircleIcon',
    title: 'Ad Removed',
    message: 'The ad has been rejected and removed from the approval queue.',
    primaryLabel: 'Back to Ads Management',
  },
  'upload-success': {
    icon: 'UploadCloudIcon',
    title: 'Upload Successful',
    message: 'The ad was created successfully and is pending review.',
    primaryLabel: 'View Uploaded Ads',
  },
  suspended: {
    icon: 'SlashIcon',
    title: 'Account Suspended',
    message: 'This account is suspended. Review reports for details.',
    primaryLabel: 'Close',
  },
}

export default {
  components: {
    BModal,
    BButton,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    variant: {
      type: String,
      default: 'ad-approved',
      validator: v => Object.keys(PRESETS).includes(v),
    },
    title: {
      type: String,
      default: '',
    },
    message: {
      type: String,
      default: '',
    },
    primaryLabel: {
      type: String,
      default: '',
    },
    secondaryLabel: {
      type: String,
      default: '',
    },
  },
  computed: {
    isOpen: {
      get() {
        return this.visible
      },
      set(val) {
        if (!val) this.$emit('close')
      },
    },
    preset() {
      return PRESETS[this.variant] || PRESETS['ad-approved']
    },
    iconName() {
      return this.preset.icon
    },
    resolvedTitle() {
      return this.title || this.preset.title
    },
    resolvedMessage() {
      return this.message || this.preset.message
    },
    resolvedPrimaryLabel() {
      return this.primaryLabel || this.preset.primaryLabel
    },
    resolvedSecondaryLabel() {
      return this.secondaryLabel || this.preset.secondaryLabel || ''
    },
  },
  methods: {
    close() {
      this.$emit('close')
    },
    onPrimary() {
      this.$emit('primary')
      this.close()
    },
    onSecondary() {
      this.$emit('secondary')
      this.close()
    },
  },
}
</script>

<style scoped lang="scss">
.outcome-wrap {
  position: relative;
  padding: 1.5rem 1rem 1rem;
}

.outcome-close {
  position: absolute;
  top: 0.5rem;
  right: 0.5rem;
  border: 0;
  background: transparent;
  color: #6e6b7b;
}

.outcome-icon {
  width: 88px;
  height: 88px;
  border-radius: 50%;
  margin: 0 auto 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

.outcome-icon--ad-approved {
  background: rgba(40, 199, 111, 0.12);
  color: #28c76f;
}

.outcome-icon--ad-removed {
  background: rgba(234, 84, 85, 0.12);
  color: #ea5455;
}

.outcome-icon--upload-success {
  background: rgba(115, 103, 240, 0.12);
  color: #011425;
}

.outcome-icon--suspended {
  background: rgba(255, 159, 67, 0.12);
  color: #ff9f43;
}

.outcome-title {
  font-weight: 700;
  margin-bottom: 0.5rem;
}

.outcome-message {
  color: #6e6b7b;
  margin-bottom: 1.25rem;
}
</style>
